module.exports = __webpack_public_path__ + "static/media/step_right_icon.386ae20c.svg";